(function($){
    $.I18n = function (options) {
        this._component_name = "i18n";
        this._defaultLanguage = 'ja';
        this._languageData = { 'ja' : {} }; 
        this._language_overlays = {};
        this._language_flags = {};
    
        this._events = {
            language_loaded: 'language_loaded',
            translation_data_loaded: 'translation_data_loaded', 
            language_applied: 'language_applied',
            language_changed: 'language_changed',
            element_translated: 'element_translated',
        };
    };
    
    $.Component.create($.I18n, {
        _init_: function(options) {
            options = options || {};
    
            // 多言語のオーバーレイの無有効のフラグ
            if (typeof(options.language_overlays_enabled) == 'boolean') {
                this._language_overlays_enabled = options.language_overlays_enabled;
            }
            else {
                this._language_overlays_enabled = false;
            }
            
            this._currentLanguage = this.get_current_language();

            this._observer = null;

            // 言語を変更するボタンのイベント
            var languageChangeButtons = document.querySelectorAll('[data-langchange]');
            var i, lang_change_buttons_n = languageChangeButtons.length;
            for (i = 0; i < lang_change_buttons_n; i++) {
                var languageChangeButton = languageChangeButtons[i];

                languageChangeButton.addEventListener(
                    ABDOUtil.getClickHandler(languageChangeButton), 
                    this._change_language_button_clicked.bind(this, languageChangeButton, languageChangeButton.dataset.langchange) ); 
            }

            this._on(this._events.language_loaded, this._initialize_observer.bind(this));
            this._setLanguage(this._currentLanguage);
        }, 

        _change_language_button_clicked: function(button, language, event) { 
            this._changeLanguage(language); 
            
            // URLのパラメータを更新  
            var url_params = ABDOUtil.get_url_params();
            if (url_params.has("lang")) {
                url_params.set("lang", language);
            }
            else {
                url_params.append("lang", language);
            }
            
            window.history.replaceState({}, "", location.pathname + "?" + url_params);

            // a.map-linkのhrefを更新
            ABDOUtil.update_map_links();
        },

        get_current_language: function() {
            var searchParams = ABDOUtil.get_url_params();
            
            if (searchParams.has("lang")) {
                return searchParams.get("lang");
            } 

            return navigator.language || navigator.userLanguage || this._defaultLanguage;
        },

        _initialize_observer: function() {
            if (!this._observer) {
                this._observer = new MutationObserver(this._mutation_observer.bind(this));
                this._observer.observe(document.body, {
                    childList: true, subtree: true
                });
            }
        },  

        _apply_overlays: function(language) {
            var viewer = ABDOUtil.getViewer(); 
            if (viewer) {
                var index, element, overlay;
                 //　現在表示されている言語のオーバーレイを削除
                for(var lang in this._language_overlays) { 
                    for (index = 0; index < this._language_overlays[lang].length; index++) {
                        element = this._language_overlays[lang][index];
                        overlay = viewer.getOverlayById(element.id);
                        if (overlay != null) {
                            viewer.removeOverlay(element.id);
                        }
                    }
                }

                // 設定した言語のオーバーレイを追加します
                if (typeof(this._language_overlays[language]) !== "undefined") {
                    for (index = 0; index < this._language_overlays[language].length; index++) {
                        element = this._language_overlays[language][index];
                        overlay = viewer.getOverlayById(element.id);
                        if (overlay == null) {
                            var location = new OpenSeadragon.Point(Number(element.dataset.locationX), Number(element.dataset.locationY));
                            var width = Number(element.dataset.width);

                            element.classList.remove('d-none');
                            element.style.display = "block"; // OSDがstyle['display']=noneと設定してしまうのでここでblockにする
                            viewer.addOverlay({
                                element: element,
                                location: location,
                                width: width
                            });
                            
                        }
                    }
                }
            }
        },

        _mutation_observer: function(mutations) {
            var i, addedIndex, mutations_n = mutations.length;

            for (i = 0; i < mutations_n; i++) {
                var mutation = mutations[i];

                for (addedIndex = 0; addedIndex < mutation.addedNodes.length; addedIndex++) {
                    var element = mutation.addedNodes[addedIndex];

                    if (element.nodeType == Node.ELEMENT_NODE) {
                        this._applyLanguage(this._currentLanguage, mutation.addedNodes[addedIndex]);
                    }
                }
            }
        },


        registerLanguageData: function(language, data) { 
            this._languageData[language] = data;
            this._emit(this._events.language_loaded, language);
        },

        registerOverlays: function(language, overlays) {  
            this._language_overlays[language] = [];

            for (var index = 0; index < overlays.length; index++) {
                var overlay_data = overlays[index];
                
                var element = document.createElement('img');
                element.id = 'overlay-' + language + '-' + index + 1;
                element.dataset.language = language;
                element.dataset.locationX = overlay_data.x;
                element.dataset.locationY = overlay_data.y;
                element.dataset.width = overlay_data.width;
                element.src = overlay_data.src;
                element.className = overlay_data.class;

                document.body.appendChild(element);

                this._language_overlays[language].push(element);
            } 
        },

        _applyCurrentLanguage: function() {
            this._applyLanguage(this._currentLanguage);
        },

        _applyLanguage: function(language, element) { 
            // if there is no language data, try to load it before applying
            if (!(language in this._languageData)) {
                this._once(this._events.language_loaded, this._applyCurrentLanguage.bind(this, language, element));
                this._load_language_data(language);
                return;
            }

            if (typeof(element) == 'undefined') {
                element = document;
            }

            this._apply_overlays(language);

            // 親を通訳
            if (element.nodeType == Node.ELEMENT_NODE) {
                this._translateHTMLElement(element);
            }
            
            // 子も通訳
            var taggedElements = element.querySelectorAll('[data-langkey], [data-lang-only]'); 
            //var taggedElements = jQuery(element).find('[data-langkey]');
            var i, tagged_elements_n = taggedElements.length;
            for (i = 0; i < tagged_elements_n; i++) {
                this._translateHTMLElement(taggedElements[i]);
            }

            // オーバーレイの画像を探して見ます
            this._emit(this._events.language_applied, language, element); 
        },

        _getTranslation: function(langkey) {
            // 現在の言語のデータがない時
            if (typeof(this._languageData[this._currentLanguage]) === 'undefined') {
                return langkey;
            }

            // キーのデータがない時も
            if (typeof(this._languageData[this._currentLanguage][langkey]) === 'undefined') {
                return langkey;
            }

            return this._languageData[this._currentLanguage][langkey];
        },

        _translateHTMLElement: function(element) {
            var applied = false;

            var langkey;
            if (typeof(element.dataset.langkey) !== 'undefined') {
                langkey = element.dataset.langkey;
                element.innerText = this._getTranslation(langkey);
                applied = true;
            }

            if ("langOnly" in element.dataset) {
                this._displayHTMLElement(element);
                applied = true;
            }

            if (applied) {
                this._emit(this._events.element_translated, element, this._currentLanguage, langkey);
            }
        },

        _displayHTMLElement: function(element) { 
            if (this._currentLanguage == element.dataset.langOnly)  {
                element.style.display = '';
            }
            else {
                element.style.display = 'None';
            } 
        },

        _set_flag: function(language, name, value) {
            var flags = this._get_flags(language);
            flags[name] = value;    
        },

        _get_flags: function(language) {
            if (typeof(this._language_flags[language]) == 'undefined') {
                this._language_flags[language] = {
                    language_data_completed: false,
                    overlay_completed: false
                };
            }

            return this._language_flags[language];
        },

        _check_flags: function(language) {
            var flags = this._language_flags[language];
            var completed_all = true;
            for (var flag in flags) {
                if (flags.hasOwnProperty(flag) &&
                    flag.indexOf('_completed') != -1 && !flags[flag]) { 
                    completed_all = false;
                    break;
                }
            }

            if (completed_all && !flags.loaded) {
                flags.loaded = true;
                this._emit(this._events.language_loaded, language);
            }
            
        },

        _load_translation_data: function(language) {
            this._set_flag(language, "language_data_completed", false);

            var json_path = 'js/lang.' + language + '.json';
            var xhr = new XMLHttpRequest(); 
            xhr.addEventListener("load", this._on_translation_data_loaded.bind(this, xhr, language, json_path));
            xhr.open("GET", json_path);
            xhr.send();  
        },

        /**
         * 
         * @param {XMLHttpRequest} xhr 
         * @param {String} language 
         */
        _on_translation_data_loaded: function(xhr, language, url) {
            if (xhr.readyState == 4 && xhr.status == 200) {  
                var response_obj = JSON.parse(xhr.responseText);
                this.registerLanguageData(language, response_obj.language_data); 
                this._set_flag(language, "language_data_completed", true);
                this._emit(this._events.translation_data_loaded, language);
                this._check_flags(language); 

                if (typeof(abdo_osd) !== "undefined") {
                    abdo_osd.addCache(url);
                }
            }
        },

        _load_translation_overlays: function(language) {
            this._set_flag(language, "overlay_completed", false);
            var json_path = 'js/overlays.' + language + '.json';
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("load",  this._on_load_translation_overlays.bind(this, xhr, language, json_path));
            xhr.open("GET", json_path);
            xhr.send();

            if (typeof(abdo_osd) !== "undefined") {
                abdo_osd.addCache(url);
            }
        },

        _on_load_translation_overlays: function(xhr, language, url) { 
            if (xhr.readyState == 4 && xhr.status == 200) { 
                var response_obj = JSON.parse(xhr.responseText);
                this.registerOverlays(language, response_obj.overlays); 
                this._set_flag(language, "overlay_completed", true);
                this._emit(this._events.translation_data_loaded, language); 
                this._check_flags(language);    
            }
        }, 

        _load_language_data: function(language) {
            if (!(language in this._languageData)) {
                this._load_translation_data(language);
            }

            if (this._language_overlays_enabled) {
                this._load_translation_overlays(language);
            }
            else {
                this._set_flag(language, "overlay_completed", true); 
                this._check_flags(language); 
            }
        },

        _setLanguage: function(language) {
            
            var hyphen_index = language.indexOf('-');

            if (hyphen_index !== -1) {
                this._currentLanguage = language.substr(0, hyphen_index);
                this._currentVariation = language.substr(hyphen_index+1);
            }
            else {
                this._currentLanguage = language;
                this._currentVariation = '';
            }
 
            this._applyCurrentLanguage();
        },

        _changeLanguage: function(language) {
            this._setLanguage(language);
            this._emit(this._events.language_changed, language);
        }, 
    }, $.OSD);  

})(ABDOMap);